import { Input } from 'antd';

function SearchBar({ value, onChange, style, searchInput = "search" }) {
  //console.log()
    return (
      <div
        style={{
          width: "380px",
          outline: "none",
          border: "none",
          padding: "4px 8px",
          borderRadius: "4px"
        }}
      >
       <Input
       value={value}
  placeholder={searchInput}
  title={searchInput} // shows full text on hover
  onChange={onChange}
  style={{
    height: '40px',
    padding: '8px 11px',
    fontSize: '16px'
  }}
/>

      </div>
    );
}

export default SearchBar;